const appendUrlParamsToInternalLinks = () => {
  const utmParams = new URLSearchParams(window.location.search);
  if (!utmParams.toString()) {
    return;
  }

  const links = document.querySelectorAll('a[href]');
  const siteOrigin = window.location.origin;

  links.forEach((link) => {
    const originalHref = link.getAttribute('href');
    if (!originalHref || originalHref.startsWith('#')) {
      return;
    }
    const url = new URL(originalHref, siteOrigin);

    if (url.origin !== siteOrigin) {
      return;
    }

    // Append UTM parameters
    for (const [key, value] of utmParams.entries()) {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    }

    // Normalize trailing slash
    let pathname = url.pathname;
    if (pathname !== '/' && pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1);
    }

    // Update the link href
    link.href = `${pathname}${url.search}${url.hash}`;
  });
};

export { appendUrlParamsToInternalLinks };